export const TRANSLATIONS_FR_DOCUMENTS_AND_DRIVE = {
  "upload.title": "Téléverser des documents",
  "upload.drag": "Glissez-déposez les fichiers ici",
  "upload.select": "Sélectionner des fichiers",
  "upload.formats": "Formats pris en charge : PDF, DOCX, XLSX, TXT, JSON, CSV, MD",
  "upload.processing": "Traitement...",
  "upload.success": "Document traité avec succès",
  "upload.error": "Erreur lors du traitement du document",
  "upload.process_immediately": "Traiter immédiatement",
  "upload.folder_name": "Nom du dossier",
  "upload.folder_placeholder": "Nom du dossier",
  "upload.tags": "Étiquettes",
  "upload.add_tag": "Étiquettes (séparées par des virgules)",
  "upload.files_to_upload": "Fichiers à téléverser",
  "upload.upload_all": "Tout téléverser",
  "upload.role_id": "Rôle d'accès",
  "upload.role_id_help": "Facultatif : limite le rôle pouvant voir ce document.",
  "upload.role_id_required": "Sélectionnez un rôle.",
  "upload.select_role": "Sélectionnez un rôle",
  "upload.loading_roles": "Chargement des rôles…",
  "upload.queued.title": "Fichier en file d'attente",
  "upload.queued.message":
    "Le fichier a été mis en file d'attente pour traitement.",
  "upload.queued.taskId": "ID de la tâche",
  "upload.queued.checkTasks":
    "Vous pouvez vérifier le statut dans la section des tâches.",
  "upload.duplicated.title": "Fichier dupliqué",
  "upload.duplicated.message":
    "Un document nommé '{{name}}' existe déjà. Voulez-vous le remplacer ?",
  "upload.duplicated.replace": "Remplacer",
  "upload.success.title": "Téléversement réussi !",
  "upload.success.message":
    "Le document '{{name}}' a été téléversé avec succès dans le dossier '{{folder}}'.",
  "documents.loading": "Chargement des documents...",
  "documents.name": "Nom",
  "documents.source": "Source",
  "documents.vectors": "Vecteurs utilisés",
  "documents.date": "Date",
  "documents.delete_document_tooltip": "Supprimer le document",
  "documents.delete_confirm.title": "Supprimer le document",
  "documents.delete_confirm.body": "Cette action est irréversible.",
  "documents.delete_confirm.confirm": "Supprimer",
  "documents.delete_confirm.error": "Impossible de supprimer le document.",
  "documents.download_document_tooltip": "Télécharger le document",
  "documents.context.ask_only_this": "Poser des questions uniquement sur ce document",
  "documents.context.confirm_only_this": "Limiter le chat à ce document ?",
  "documents.no_documents":
    "Aucun document indexé. Téléversez des documents dans la section 'Téléverser des documents'.",
  "documents.refresh": "Actualiser",
  "documents.indexed_documents":
    "Liste des documents actuellement indexés dans le système.",
  "documents.indexed_documents_title": "Documents indexés",
  "documents.tab_overview": "Aperçu",
  "documents.tab_network": "Sémantique",
  "documents.tab_details": "Détails",
  "documents.tab_viewer": "Visionneuse",
  "documents.sidebar_types": "Types",
  "documents.types_distribution": "Répartition par type",
  "documents.type_.pdf": "PDF",
  "documents.type_.docx": "DOCX",
  "documents.type_.txt": "TXT",
  "documents.type_.csv": "CSV",
  "documents.type_.xlsx": "XLSX",
  "documents.type_.pptx": "PPTX",
  "documents.type_.email": "E-mail",
  "documents.type_.other": "Autre",
  "documents.type_.md": "MD",
  "documents.group_today": "Aujourd'hui",
  "documents.group_last3days": "3 derniers jours",
  "documents.group_lastweek": "Semaine dernière",
  "documents.group_lastmonth": "Mois dernier",
  "documents.group_older": "Plus anciens",
  "documents.domains": "Domaines",
  "documents.other_domains": "Autres domaines",
  "documents.documents_word": "documents",
  "documents.search_domain": "Rechercher un domaine...",
  "documents.no_domain_results": "Aucun résultat",
  "documents.subdomains": "Sous-domaines",
  "documents.clear_filter": "Effacer le filtre",
  "documents.back": "Retour",
  "documents.domain_distribution": "Répartition par domaine",
  "documents.subdomain_distribution":
    "Répartition par sous-domaine de {{domain}}",
  "documents.select_domain_hint":
    "Sélectionnez un domaine pour voir ses sous-domaines et documents.",
  "documents.select_subdomain_hint":
    "Sélectionnez un sous-domaine pour voir ses documents.",
  "documents.redirecting_to_details":
    "Redirection vers les détails du document...",
  "documents.details_for_type": "Documents du type : {{type}}",
  "documents.details_for_domain": "Documents du domaine : {{domain}}",
  "documents.details_all": "Tous les documents",
  "documents.group_type": "Type",
  "documents.group_domain": "Domaine",
  "documents.no_documents_in_group": "Aucun document dans ce groupe.",
  "documents.no_documents_found": "Aucun document trouvé.",
  "drive.viewer_aria_label": "Visionneuse Mon Drive (lecture seule)",
  "drive.search_placeholder": "Rechercher dans Mon Drive",
  "drive.my_drive": "Mon Drive",
  "drive.filter.type.aria": "Filtrer par type",
  "drive.filter.type.label_all": "Type : Tous",
  "drive.type.folder": "Dossier",
  "drive.type.doc": "Document",
  "drive.type.sheet": "Feuille de calcul",
  "drive.type.slide": "Présentation",
  "drive.type.pdf": "PDF",
  "drive.type.image": "Image",
  "drive.type.video": "Vidéo",
  "drive.type.zip": "ZIP",
  "drive.type.other": "Autres",
  "drive.filter.owner.aria": "Filtrer par propriétaire",
  "drive.filter.owner.label_all": "Propriétaire : N'importe lequel",
  "drive.owner.you": "Vous",
  "drive.owner.external": "Externe",
  "drive.owner.any": "N'importe lequel",
  "drive.details": "Détails",
  "drive.tree_aria_label": "Arborescence Mon Drive",
  "drive.breadcrumbs_aria_label": "Chemin actuel",
  "drive.view.list": "Liste",
  "drive.view.grid": "Grille",
  "drive.view.list_aria": "Vue en liste",
  "drive.view.grid_aria": "Vue en grille",
  "drive.sort.by": "Trier par",
  "drive.sort.dir": "Ordre de tri",
  "drive.sort.key.name": "Nom",
  "drive.sort.key.type": "Type de fichier",
  "drive.sort.key.owner": "Propriétaire",
  "drive.sort.key.modified": "Dernière modification",
  "drive.sort.key.size": "Taille",
  "drive.dir.asc": "Asc",
  "drive.dir.desc": "Desc",
  "drive.results_showing": "Affichage",
  "drive.table.aria_label": "Liste d'éléments",
  "drive.table.name": "Nom",
  "drive.table.file_type": "Type de fichier",
  "drive.table.owner": "Propriétaire",
  "drive.table.last_modified": "Dernière modification",
  "drive.table.size": "Taille",
  "drive.shared": "Partagé",
  "drive.preview": "Aperçu",
  "drive.details.name": "Nom",
  "drive.details.type": "Type",
  "drive.details.location": "Emplacement",
  "drive.details.owner": "Propriétaire",
  "drive.details.size": "Taille",
  "drive.details.created": "Création",
  "drive.details.last_modified": "Dernière modification",
  "drive.details.shared": "Partagé",
  "drive.yes": "Oui",
  "drive.no": "Non",
  "drive.details.permissions": "Permissions",
  "drive.permissions.read_only": "Lecture seule",
  "drive.no_selection_hint": "Sélectionnez un élément pour voir ses détails.",
  "drive.filters_aria": "Filtres",
  "drive.hide_tree": "Masquer l'arbre",
  "drive.show_tree": "Afficher l'arbre",
  "drive.refreshing": "Actualisation...",
  "drive.loading_files": "Chargement des fichiers...",
  "drive.preview.loading": "Chargement de l'apercu...",
  "drive.preview.not_available": "Aperçu non disponible",
  "drive.by_date": "Par date",
  "drive.status.items": "elements",
  "drive.status.items_one": "element",
  "drive.status.of": "sur",
  "drive.status.selected": "selectionnes",
  "drive.status.selected_one": "selectionne",
  "drive.type.email": "Courriel",
  "drive.context.move_to": "Déplacer vers",
  "drive.context.no_move_targets": "Aucun dossier disponible",
  "drive.move_dialog.title": "Deplacer des documents",
  "drive.move_dialog.search": "Rechercher des dossiers",
  "drive.move_dialog.items_suffix": "elements",
  "drive.move_dialog.moving": "Deplacement...",
  "drive.move_dialog.error": "Le fichier n'a pas pu etre deplace. Verifiez les autorisations ou reessayez.",
  "drive.move_dialog.invalid_target": "Selectionnez un dossier de destination valide.",
  "drive.bytes": "octets",
  "documents.error_loading": "Erreur de chargement des documents",
  "documents.error_deleting": "Erreur lors de la suppression du document",
  "documents.selected_type": "Type sélectionné",
  "documents.selected_document": "Document sélectionné",
  "documents.group_lastWeek": "Semaine dernière",
  "documents.group_lastMonth": "Mois dernier",
  "upload.clear_completed": "Effacer les éléments terminés",
  "drive.contextMenu.generateSummary": "Générer un résumé",
  "drive.generateSummary.modalTitle": "Documents sélectionnés",
  "drive.generateSummary.modalHint": "Un résumé exécutif de ces documents sera généré.",
  "drive.generateSummary.goToGenerate": "Aller à Générer",
  "drive.generateSummary.noDocuments": "Sélectionnez au moins un document indexé.",
  "documents.versions.action": "Historique des versions",
  "documents.versions.title": "Historique des versions",
  "documents.versions.empty": "Ce document n'a pas encore de versions.",
  "documents.versions.error": "Impossible de charger l'historique des versions.",
  "documents.versions.active": "En vigueur",
  "documents.versions.close": "Fermer",
};
